import { useMemo, useState } from 'react';

import { Select } from '@components/custom-select/select';
import {
    SelectItem,
    SelectItemType,
} from '@components/custom-select/select-item';
import CustomInput from '@components/custom-input/custom-input.component';

import styles from './submission-reason.module.scss';

type Props = {
    reasons: { id: number; text: string }[];
    onReason: (reason: string) => void;
};

const SubmissionReason = ({ reasons, onReason }: Props) => {
    const items: SelectItemType[] = useMemo(() => {
        return reasons.map((reason) => ({
            id: reason.id,
            label: reason.text,
        }));
    }, [reasons]);

    const handleSelect = (item: SelectItemType) => {
        if (item.label === 'Otro') {
            return setInputShown(true);
        }
        setInputShown(false);
        onReason(item.label);
    };

    const [inputShown, setInputShown] = useState(false);

    return (
        <div className={styles.container}>
            <label>Razón de carga manual</label>
            <Select
                items={items}
                placeholder="Selecciona una razón"
                onSelect={handleSelect}
            >
                {items.map((item) => (
                    <SelectItem key={item.id} id={item.id}>
                        {item.label}
                    </SelectItem>
                ))}
            </Select>
            {inputShown && (
                <CustomInput
                    width="100%"
                    placeholder="Explique la razón aquí"
                    type="text"
                    onChange={onReason}
                />
            )}
        </div>
    );
};

export { SubmissionReason };
